import CityPageTemplate from "../city-template/CityPageTemplate";
import { tysonsVaConfig } from "./data";

export default function TysonsVaPage() {
  return <CityPageTemplate config={tysonsVaConfig} />;
}